import UdeskLocales from 'UdeskLocales';
import React, { useEffect, useState } from 'react';
import { FormBuilder } from 'udesk-ui';
import type { FormProps } from 'udesk-ui/lib/form-builder/types/form';
import { getCaseLibraryCategorys } from 'src/api/caseLibraryCategorys';
import { getCaseLibraryCategorysFromcc } from 'src/api/caseLibraryCategorys/fromcc';
import { CaseLibraryCategoryFoundResponse } from 'src/api/types';

const Template = (props) => {
    const { taskId, autoMateCaseConf = {}, onChange } = props;

    const [caseLibrary, setCaseLibrary] = useState<CaseLibraryCategoryFoundResponse[]>([]);
    const [ccLibrary, setCCLibrary] = useState<CaseLibraryCategoryFoundResponse[]>([]);
    const [form] = FormBuilder.useForm();

    useEffect(() => {
        getCaseLibraryCategorys({
            params: {
                taskId,
            },
        }).then((resp) => {
            setCaseLibrary(resp.data || []);
        });
        getCaseLibraryCategorysFromcc().then((resp) => {
            setCCLibrary(resp.data || []);
        });
    }, [taskId]);

    const onValuesChange = (changedValues, allValues) => {
        onChange(allValues);
    };

    const config: FormProps = {
        initialValues: autoMateCaseConf,
        // customComponents: { OtherSettings },
        onValuesChange: onValuesChange,
        fields: [
            {
                name: 'caseLibraryId',
                label: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                    .caseLibraryId,
                type: 'Select',
                tooltip:
                    UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                        .caseLibraryIdTip,
                props: {
                    style: {
                        width: 250,
                    },
                    allowClear: true,
                    options: caseLibrary.map((item) => ({ label: item.name, value: item.id })),
                    placeholder: UdeskLocales['current'].labels.pleaseSelect,
                },
            },
            {
                name: 'udeskCaseLibraryId',
                label: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                    .udeskCaseLibraryId,
                tooltip:
                    UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                        .udeskCaseLibraryIdTip,
                type: 'Select',
                props: {
                    style: {
                        width: 250,
                    },
                    allowClear: true,
                    options: ccLibrary.map((item) => ({ label: item.name, value: item.id })),
                    placeholder: UdeskLocales['current'].labels.pleaseSelect,
                },
            },
        ],
        footerRender: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    return (
        <div className="auto-add-filter-edit-item-row-filter">
            <FormBuilder {...config} form={form} />
        </div>
    );
};

export default Template;
